const name = 'circle-v';

const contents = '<path fill="#FFF" d="M34.356 55h-6.795l-9.197-28.42h5.717l5.055 16.406 1.74 6.794h.414l1.823-6.794 5.054-16.406h5.469z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'V',
};

export default icon;
